<div class="text-center my-5">
	<h1>Page Not Found</h1>
	<p>
		If you've received this error unexpectedly, let us know at
		<a href="mailto:support@graduationalliance.com"
			>support&#64;graduationalliance.com</a
		>
	</p>
</div>
